// extracted by mini-css-extract-plugin
export default {"container":"creditRiskScore_container__hzkXA","value":"creditRiskScore_value__O313r"};